import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { ListItem } from '../components/blocks/ListItem';

export const isListItem = isElementType(ListItem);
